module.exports = __webpack_public_path__ + "static/media/8OLA18.900a3b9e.jpg";